export default function FlooringHero() {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/423b95a5f6a2cd7f13f2f1181b4e7145.jpg"
          alt="Professional Flooring Services in El Paso"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center text-white w-full">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          Expert Flooring Contractors in El Paso
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-white/95">
          Transform your space with premium flooring installation from hardwood and tile to luxury vinyl and carpet
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#contact"
            className="px-8 py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors text-lg whitespace-nowrap cursor-pointer"
          >
            Get Free Quote
          </a>
          <a
            href="#services"
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition-colors text-lg border-2 border-white/30 whitespace-nowrap cursor-pointer"
          >
            Explore Options
          </a>
        </div>
      </div>
    </section>
  );
}
